export { DigitalClock, DigitalClockItem } from './DigitalClock';
export type {
  DigitalClockProps,
  DigitalClockSlots,
  DigitalClockSlotProps,
  ExportedDigitalClockProps,
  DigitalClockItemProps,
} from './DigitalClock.types';

export { digitalClockClasses, getDigitalClockUtilityClass } from './digitalClockClasses';
export type { DigitalClockClasses, DigitalClockClassKey } from './digitalClockClasses';
